module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-779-retro.0c831690.jpg";